import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h5>{`I am an inquisitive yet optimistic individual who is currently doing my fourth semester of Computer Science (Data Science) course in the number one and most prestigious university in Malaysia, University of Malaya (UM). I transitioned into data science from a pure science background in secondary school and matriculation. I joined tech-related clubs in UM during my second year to give out the best of mine to the juniors so that they will not feel lost as I have experienced especially during the first 2 semesters in UM. I am constantly seeking for exciting and adventurous challenges while at the same time consistently exploring new knowledge not limited to technology for self-improving.`}</h5>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      